import { inject, Injectable } from '@angular/core';
import { PlaylistVideo } from '../../services/playlist.service';
import { HotToastService } from '@ngxpert/hot-toast';
import { VideoAddedComponent } from './video-added/video-added.component';

/**
 * https://ngxpert.github.io/hot-toast/#examples
 * Uuri "Component Data" sectionit
 */

const toastTime = 7000;

const testToast: PlaylistVideo = {
  channel: 'Gorillaz',
  duration: 269,
  nickname: 'herrsiim',
  position: 73,
  title: 'Gorillaz - Clint Eastwood (Official Video)',
  uploadedAt: '2016-06-28T12:18:36Z',
  videoId: 73,
  views: 905998845,
  youtubeId: '1V_xRb0x9aw',
};

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  toast = inject(HotToastService);
  
  newVideoAdded(videoData: PlaylistVideo) {
    this.toast.show(VideoAddedComponent, {
      theme: 'snackbar',
      position: 'bottom-right',
      duration: toastTime,
      className: 'clear-toast',
      data: videoData,
    });
  }

  testToast() {
    this.toast.show(VideoAddedComponent, {
      theme: 'snackbar',
      position: 'bottom-right',
      duration: toastTime,
      className: 'clear-toast',
      data: testToast,
    });
  }

  // nowPlaying(videoData: PlaylistVideo) {
  //   this.toast.show(VideoAddedComponent, {
  //     theme: 'snackbar',
  //     position: 'bottom-right',
  //     duration: toastTime,
  //     className: 'clear-toast',
  //     data: videoData,
  //   });
  // }
}
